// ==================== CONFIGURACIÓN DE API ====================
// Configuración centralizada para las conexiones al backend

// URL base del API según el entorno
const backendUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
export const API_BASE_URL = `${backendUrl}/api`;

// Timeout para las peticiones (en milisegundos)
export const API_TIMEOUT = 10000;

// Headers por defecto
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
};

const apiConfig = {
  API_BASE_URL,
  API_TIMEOUT,
  DEFAULT_HEADERS
};

export default apiConfig;
